import type { IWarehouseRepository } from '../domain/IWarehouseRepository'

export class DeleteWarehouseUseCase {
    constructor(private readonly warehouseRepository: IWarehouseRepository) {}

    async execute(warehouseId: string): Promise<void> {
        if (!warehouseId) {
            throw new Error('Warehouse ID is required')
        }

        await this.warehouseRepository.delete(warehouseId)
    }
}
